import { YoutubePlaylistContainerConstants } from './constants';
import {
  GetYoutubePlaylistActionType,
  GetYoutubeVideoLengthsActionType,
  ToggleYoutubePlaylistModalOpenActionType,
} from './types/actions.types';

export const toggleYoutubePlaylistModalOpen = (): ToggleYoutubePlaylistModalOpenActionType => ({
  type: YoutubePlaylistContainerConstants.TOGGLE_YOUTUBE_PLAYLIST_MODAL_OPEN,
});

export const getYoutubePlaylist = (
  playlistId: string
): GetYoutubePlaylistActionType => ({
  type: YoutubePlaylistContainerConstants.GET_YOUTUBE_PLAYLIST,
  payload: { playlistId },
});

export const getYoutubeVideoLengths = (
  videoIds: string[]
): GetYoutubeVideoLengthsActionType => ({
  type: YoutubePlaylistContainerConstants.GET_VIDEO_LENGTHS,
  payload: { videoIds },
});
